
import React, { useState, useEffect, memo } from 'react';
import ValuesStore from '../../store/values-store';

import utils from '../../dependencies/custom/react-utilities';
import { Space, Button, Card, Input, Empty, Form, Tabs, Select } from 'antd';

import useTable from '../../hooks/table';
import useAdd from '../../hooks/add';
import useDelete from '../../hooks/delete';
import Settings from '../../dependencies/custom/settings';

import useUpload from '../../hooks/upload';
import useExcel from '../../hooks/excel';
import Utilities from '../../dependencies/custom/react-utilities';
import AppContainer from '../../components/container';

const ExtraGradeCorrections = (props) => {
    const valuesStore = ValuesStore();
    const metaName = 'upload_student_form';
    const add = useAdd(metaName, 'table_name');
    const del = useDelete();
    const { filters, filterTypes } = utils.generateTableFilters();
    const [result, setResult] = useState([]);
    const [errors, setErrors] = useState([]);

    const upload = useUpload()
    const excel = useExcel();
    // const [preferredHeadings, setPreferredHeadings] = useState(['Title', 'FirstName', 'LastName', 'MiddleName', 'Sex', 'DoB', 'Telephone', 'Email', 'Hall', 'IndexNumber', 'ApplicantID', 'StudentNo', 'StartAcadYr', 'CurrentAcadYr']);
    const [preferredHeadings, setPreferredHeadings] = useState(
        {
            title: 'Title',
            fname: 'FirstName',
            lname: 'LastName',
            mname: 'MiddleName',
            sex: 'Sex(Male/Female)',
            dob: 'DoB(YYYY-MM-DD)',
            telephone: 'Telephone',
            personal_email: 'Email',
            hall: 'Hall',
            index_no: 'IndexNumber',
            applicant_id: 'ApplicantID',
            student_no: 'StudentNo',
            start_acadyr: 'StartAcadYr(YYYY/YYYY)',
            current_acadyr: 'CurrentAcadYr(YYYY/YYYY)',
            citizenship: 'Citizenship',
            status: 'Status(completed/active/deferred/suspended)',
            student_no: 'StudentNumber',

        }
    );

    const headings = Object.values(preferredHeadings);

    //and key value that points to the table names from zustand store.    
    const table = useTable(
        {
            pagination: {
                current: 1,
                pageSize: 10,
                position: ['bottomRight', 'topRight']
            },
            filters: { ...filters },
            filterTypes: { ...filterTypes }
        },
        undefined,
        'post',
        'result',
        'totalCount',
        'IndexNumber',
        { /*alias: 'LIKE', acadyr: 'LIKE', semester: 'IN', end_date: 'IN', is_active: 'IN' */ },
        { table: '', fields: [''] });

    const tableWithErrors = useTable(
        {
            pagination: {
                current: 1,
                pageSize: 10,
                position: ['bottomRight', 'topRight']
            },
            filters: { ...filters },
            filterTypes: { ...filterTypes }
        },
        undefined,
        'post',
        'result',
        'totalCount',
        'id',
        { /*alias: 'LIKE', acadyr: 'LIKE', semester: 'IN', end_date: 'IN', is_active: 'IN' */ },
        { table: '', fields: [''] });

    const rejectedList = useTable(
        {
            pagination: {
                current: 1,
                pageSize: 10,
                position: ['bottomRight', 'topRight']
            },
            filters: { ...filters },
            filterTypes: { ...filterTypes }
        },
        undefined,
        'post',
        'result',
        'totalCount',
        'IndexNumber',
        { /*alias: 'LIKE', acadyr: 'LIKE', semester: 'IN', end_date: 'IN', is_active: 'IN' */ },
        { table: '', fields: [''] });



    const columns = headings?.map(v => {
        return { title: v, dataIndex: v }
    });
    const rejectedListColumns = [
        // ...columns,
        {
            title: 'IndexNumber',
            dataIndex: 'IndexNumber'
        },
        {
            title: 'ApplicantID',
            dataIndex: 'ApplicantID'
        },
        {
            title: 'Title',
            dataIndex: 'Title'
        },
        {
            title: 'FirstName',
            dataIndex: 'FirstName'
        },
        {
            title: 'LastName',
            dataIndex: 'LastName'
        },
        {
            title: 'MiddleName',
            dataIndex: 'MiddleName'
        },
        {
            title: 'Error',
            dataIndex: 'error',
        }
    ];
    

    const columnsWithErrors = (
        [
            {
                title: 'Index Number',
                dataIndex: 'IndexNumber',
                ...table.getColumnSearchProps('IndexNumber'),
            },
            {
                title: 'Applicant ID',
                dataIndex: 'ApplicantID',
                ...table.getColumnSearchProps('ApplicantID'),
            },
            {
                title: 'Error',
                dataIndex: 'error',
                render(v, record) {
                    return <label className='text-danger'>{v}</label>
                }
            },
        ]);

    function straightUpload() {
        upload.setCustomBeforeUpload({
            async beforeUpload(file, acceptedFileTypes) {
                if (!acceptedFileTypes.includes(file?.type)) {
                    utils.showNotification(undefined, 'File type not allowed', 'text-danger');
                    return;
                }

                const result = await excel.importXLSX(file);
                if (!result.length) {
                    utils.showNotification(undefined, 'File does not contain data', 'text-danger');
                    return;
                }

                //VALIDATING HEADINGS/COLUMNS
                const headings = Object.keys(result[0]);
                for (let h of headings) {
                    if (!headings?.includes(h)) {
                        utils.showNotification(undefined, `Unrecognized heading (${h})`, 'text-danger');
                        return;
                    }
                }

                //CHECKING FOR DUPLICATE INDEX NUMBERS
                let tracker = {};
                let duplicates = [];
                let clean = [];
                let noIDsFound = [];
                let index = 1;
                for (let data of result || []) {
                    if (!('IndexNumber' in data) || !('ApplicantID' in data) || !data['IndexNumber'] || !data['ApplicantID']) {
                        noIDsFound.push({ ...data, error: `No index number or applicant ID found at position ${index}` });
                        continue;
                    }
                    if (data['IndexNumber'] in tracker || data['ApplicantID'] in tracker) {
                        duplicates.push({ ...data, error: `Duplicate index number or applicant_id found for ${data['IndexNumber']}`, id: utils.generateUuid() });
                    } else {
                        clean.push(data);
                        tracker[data['IndexNumber']] = data;
                        tracker[data['ApplicantID']] = data;
                    }
                    index++;
                }
                //USING DUPLICATES TO FIND CORRESPONDING RECORD IN CLEAN DATA 
                let final = [];
                let finalDup = [];
                for (let c of clean || []) {
                    const indexInClean = c['IndexNumber'];
                    const appIDInClean = c['ApplicantID'];
                    for (let d of duplicates || []) {
                        const indexInDup = d['IndexNumber'];
                        const appIDInDup = d['ApplicantID'];
                        if (indexInClean == indexInDup || appIDInClean == appIDInDup) {
                            finalDup.push({ ...c, error: `Duplicate index number or applicant_id found for ${c['IndexNumber']}`, id: utils.generateUuid() });
                            finalDup.push(d);
                        } else {
                            final.push(c);
                        }
                    }
                }

                const finalData = final.length ? final : clean;
                setResult(finalData);
                setErrors([...finalDup, noIDsFound]);
                tableWithErrors.setData([...finalDup, ...noIDsFound]);

                table.setData(finalData);
                // tableWithErrors.setData([...withErrors, ...finalDup]);
                utils.showNotification(undefined, 'File upload successful', 'text-success');
            }
        });
    }
    // {"sql":"SELECT alias,name FROM programs","key":"alias","value":"name","endpoint":"get_admin_programs","endpoint_result_key":"result"}
    function genForm() {
        setTimeout(() => {
            const upload_student_form = 'upload_student_form'
            valuesStore.setValue(metaName, [
                {
                    id: '', table_name: upload_student_form,
                    column_name: 'program', col_real_name: 'Program', type: 'sqlSelect',
                    options: '{"sql":"SELECT short_name,alias from programs WHERE show_hide=1","key":"alias","value":"short_name","endpoint":"get_admin_programs","endpoint_result_key":"result"}',
                    backend_visible: 1,
                    rank: 1, validator: 'validateEmptyString'
                },
                {
                    id: '', table_name: upload_student_form,
                    column_name: 'session', col_real_name: 'Session', type: 'sqlRadio',
                    options: '{"sql":"SELECT session,alias from sessions WHERE is_active = 1","key":"alias","value":"session"}',
                    backend_visible: 1,
                    rank: 1, validator: 'validateEmptyString'
                },
                {
                    id: '', table_name: upload_student_form,
                    column_name: 'student_type', col_real_name: 'Student Type', type: 'csvSelect',
                    options: 'Local,Foreign',
                    backend_visible: 1,
                    rank: 1, validator: 'validateEmptyString'
                },
                {
                    id: '', table_name: upload_student_form,
                    column_name: 'current_level', col_real_name: 'Current Level', type: 'sqlSelect',
                    options: '{"sql":"SELECT level FROM level","key":"level","value":"level"}',
                    backend_visible: 1,
                    rank: 1, validator: 'validateEmptyString'
                },
                {
                    id: '', table_name: upload_student_form,
                    column_name: 'current_sem', col_real_name: 'Current Semester', type: 'sqlSelect',
                    options: '{"sql":"SELECT semester,alias from semester","key":"alias","value":"semester"}',
                    backend_visible: 1,
                    rank: 1, validator: 'validateEmptyString'
                },
                {
                    id: '', table_name: upload_student_form,
                    column_name: 'generate_indexno', col_real_name: 'Allow system to generate Index Number', type: 'csvRadio',
                    options: 'No,Yes',
                    backend_visible: 1,
                    rank: 1, validator: 'validateEmptyString'
                },
            ]);
            add.setTblName(upload_student_form);
        }, 1000);
    }


    function fileDelete() {
        upload.setDelFile({
            delete: async (file) => {
                table.setData([]);
                setResult([]);
                tableWithErrors.setData([]);
                rejectedList.setData([]);
                setErrors([]);
            }
        });
    }

    async function saveBatchResult() {
        const form = add.validateShowErrorMessage();
        if (!form.isValid) return;

        if (result.length <= 0) {
            Utilities.showNotification('Attention', 'No result data found');
            return;
        }
        let res = await utils.requestWithReauth('post', `${Settings.backend}/save_students_list`, null, { form: add.record, result, preferredHeadings });
        if (res?.status == "Ok") {
            //show rejected list here
            rejectedList.setData(res.errors);
            utils.showNotification(undefined, 'Operation successful', 'text-success');
        } else {
            utils.showNotification(undefined, res.msg);
        }
    }





    useEffect(() => {
        table.setColumns(columns);
        tableWithErrors.setColumns(columnsWithErrors);
        rejectedList.setColumns(rejectedListColumns);
        straightUpload();
        fileDelete();
        upload.setNumFiles(1);
        upload.setAcceptedFiles(['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel']);
        genForm();

    }, []);




    function theTabs() {
        return [
            {
                label: <><label className='d-none d-md-flex'>Upload List</label></>,
                key: 'upload_list',
                children: uploadList(saveBatchResult)
            }
        ];
    }


    function downloadTemplate() {
        excel.exportXLSX(headings, [], 'results_template', `students_list_template_${new Date().getDate()}.xlsx`);
    }

    function downloadRejectedList() {
        const cols = [...headings,'error'];
        let newData = [...rejectedList?.data];
        if (rejectedList?.data.length) {
            let firstEntry = rejectedList?.data[0];
            for (let cl of cols) {
                if (!(cl in firstEntry) || !firstEntry[cl]) {
                    firstEntry[cl] = 'N/A';
                }
            }
            newData[0] = firstEntry;
        }        
        excel.exportXLSX(Object.keys(newData[0]), newData, 'rejected_list', `rejected_list_${new Date().getDate()}.xlsx`);
    }


    function uploadList(saveBatchResult) {
        return <div className='rowx'>
            <div className='row'>
                <div className='col-md-4'>
                    {add.form}
                </div>
                <div className='col-md-8'>
                    <label className='text-primary fw-bold'>Rejected list after save operation will appear below</label>
                    <Button className='ms-2' onClick={e => downloadRejectedList()} icon={<i className='fas fa-download me-1' />}>Download</Button>
                    <div className='table-responsive h-scrolling-wrapper mt-1'>
                        {rejectedList.table}
                    </div>
                </div>
            </div>
            <div className='col-md-4x mt-2'>
                {upload.uploader('fileUpload', '', 'uploadMap', ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'])}
                <Button onClick={e => saveBatchResult()} className='btn-success border-0 mt-2'> <i className='me-1 fas fa-save' /> Save</Button>
            </div>
            <div className='row'>
                <div className='col-md-8'>
                    <div className='table-responsive h-scrolling-wrapper'>
                        {table.tableWithHeader(() => <label className='text-primary fw-bold'>Total records {result?.length}</label>)}
                    </div>
                </div>
                <div className='col-md-4'>
                    <div className='table-responsive h-scrolling-wrapper'>
                        {tableWithErrors.tableWithHeader(() => <label className='text-danger fw-bold'>Total records with errors {errors.length}</label>)}
                    </div>
                </div>
            </div>
        </div>
        // </div >
    }



    return (
        <>
            <AppContainer
                title="Upload Student List"
                extra={<Button onClick={downloadTemplate} className='btn-primary border-0' icon={<i className='fas fa-download me-1' />}>Download Template</Button>}
                children={
                    <Tabs
                        items={theTabs()}
                    />
                }
            />
        </>
    );
}

export default memo(ExtraGradeCorrections);